import { LayoutGrid, Settings, Wrench, Grid2x2 } from 'lucide-react';
import { Container } from '../ui/Container/Container';
import { useScrollReveal } from './useScrollReveal';

const DIFFS = [
  {
    bg: 'rgba(91,138,181,0.08)',
    color: '#5b8ab5',
    icon: <LayoutGrid width={18} height={18} />,
    title: 'Visual, not linear',
    desc: "Ideas don't happen in a chat thread. They branch, merge, and evolve. A canvas lets you see your entire creative process at once.",
  },
  {
    bg: 'rgba(150,120,180,0.08)',
    color: '#9678b4',
    icon: <Settings width={18} height={18} />,
    title: 'Mix and match models',
    desc: 'Use Nano Banana for photorealism, Recraft for illustration, Sora for video — all in the same canvas, on the same prompt.',
  },
  {
    bg: 'rgba(200,212,90,0.12)',
    color: '#a8b44a',
    icon: <Wrench width={18} height={18} />,
    title: 'Templates that scale',
    desc: 'Save any workflow as a reusable template. Your team uses it across projects. Consistency without repetition.',
  },
  {
    bg: 'rgba(62,69,87,0.06)',
    color: '#3e4557',
    icon: <Grid2x2 width={18} height={18} />,
    title: 'Bring your references',
    desc: 'Drop in inspiration images, old work, brand assets. Connect up to 14 reference images to a single generation. Full context, every time.',
  },
];

export function LandingDifferentiators() {
  const ref = useScrollReveal<HTMLDivElement>();

  return (
    <section className="py-12 md:py-20 bg-white" id="why">
      <Container size="lg" className="max-w-[1100px]">
        <div ref={ref} className="lp-reveal text-center">
          <p className="font-mono text-xs uppercase tracking-[0.14em] text-primary-500 mb-3">
            Why Cascady
          </p>
          <h2
            className="text-[clamp(1.75rem,4vw,2.6rem)] font-semibold leading-[1.15] tracking-tight mb-3"
            style={{ color: '#1d2939' }}
          >
            Built for how creativity
            <br />
            <em style={{ fontFamily: "'Playfair Display',Georgia,serif", fontStyle: 'italic', fontWeight: 400, color: '#6b529e' }}>
              actually works.
            </em>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
          {DIFFS.map((d) => (
            <div
              key={d.title}
              className="bg-white border border-black/[0.06] rounded-[14px] p-[1.3rem] transition-all hover:border-black/[0.1]"
            >
              <div
                className="w-9 h-9 rounded-[9px] flex items-center justify-center mb-3.5"
                style={{ background: d.bg, color: d.color }}
              >
                {d.icon}
              </div>
              <h3 className="text-[0.95rem] font-semibold text-[#1d2939] mb-1">{d.title}</h3>
              <p className="text-[0.8rem] text-[#5a6478] leading-[1.55]">{d.desc}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
